import styled from 'styled-components';
import { colours } from 'styling/colours';
import Button from 'components/Button/Button';
import { observer } from 'mobx-react';
import { useBeaconlistStore } from 'contexts/RootStore.context';

const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 10px;
  padding-left: 10px;
  span {
    margin-right: 10px;
    color: ${colours.secondaryText};
  }
`;

export const RefreshData = observer(({ onRefresh }: { onRefresh: () => void }) => {


  const { loading, getLatestUpdateText } = useBeaconlistStore()

  return (
    <StyledContainer>
      <span>{getLatestUpdateText}</span>
      <Button outline onClick={onRefresh} isLoading={loading}>
        Refresh
      </Button>
    </StyledContainer>
  );
})
